import React from "react";
import { cn } from "../../lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "secondary" | "success" | "warning" | "destructive" | "outline" | "brand";
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "default",
  className,
}) => {
  const variants = {
    // Default: Blue/Primary
    default:
      "bg-blue-500/15 text-blue-700 dark:text-blue-300 border border-blue-500/20 backdrop-blur-sm",
    // Brand: solid emerald accent, intentionally identical in light/dark
    brand: "bg-emerald-600 text-white border border-emerald-600",
    // Secondary: Neutral slate
    secondary:
      "bg-slate-500/10 text-slate-700 dark:text-slate-200 border border-slate-500/20 backdrop-blur-sm",
    // Success: Green
    success:
      "bg-green-500/15 text-green-700 dark:text-green-300 border border-green-500/20 backdrop-blur-sm",
    // Warning: Amber
    warning:
      "bg-amber-500/15 text-amber-700 dark:text-amber-300 border border-amber-500/20 backdrop-blur-sm",
    // Destructive: Red
    destructive:
      "bg-red-500/15 text-red-700 dark:text-red-300 border border-red-500/20 backdrop-blur-sm",
    // Outline: Standard
    outline: "text-foreground border border-border backdrop-blur-sm",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  );
};
